const breakpoints = [40, 52, 64];

const breakpointsEm = breakpoints.map(n => n + "em");
export const breakpointsPx = breakpoints.map(n => n * 16);

export default breakpointsEm;
